<template>
	<vs-dropdown
		class="cbs-hint cursor-pointer leading-none"
		v-bind="$attrs"
		v-on="$listeners"
		vs-trigger-click
		vs-custom-content
	>
		<i class="nucleo nucleo-c-info font-bold btn-trigger"></i>
		<vs-dropdown-menu>
			<div class="cbs-hint__data flex w-48 sm:w-full max-w-xs md:max-w-md">{{ data }}</div>
		</vs-dropdown-menu>
	</vs-dropdown>
</template>

<script>
export default {
	name: "CbsHint",
	inheritAttrs: false,
	props: {
		data: {
			required: true
		},
	}
};
</script>

<style lang="scss" scoped>
.cbs-hint {
	&.vs-con-dropdown {
		margin-right: -10px;

		.btn-trigger {
			margin-right: 10px;
		}
	}
}
</style>
